<script setup>
const route = useRoute()
const { data, refresh } = await useFetch(`/api/post/tag?id=${route.params.id}`, { key: `pt${route.params.id}` })
const loading = ref(false)
const { Settings } = useSettings()
const selectedPost = ref({})

const infiniteScrolling = async (isIntersecting) => {
  if (isIntersecting && data?.value?.posts.length) {
    loading.value = true
    const ret = await $fetch(`/api/post/tag/?id=${route.params.id}&after=${data?.value.posts[data?.value?.posts.length-1].date}`)

    if (ret?.posts.length) {
      data.value.posts.push(...ret.posts)
    }
    loading.value = false
  }
}

const editPostDialog = ref()
function editPost(post) {
  editPostDialog.value.open(post)
}

</script>

<template>
  <section>
    <Head><Title>{{ Settings.name }} - #<span v-html='data?.tag.name'/></Title></Head>
    <h2 class="mb-6">{{$t('Tag')}} - {{data?.tag?.name}}</h2>
    <EditPost ref="editPostDialog" :post="selectedPost" @update="refresh"/>
    <section class='container max-w-80 postContainer'>
      <Post v-for='post in data?.posts || []' :key='post.id' :post='post'
        @edit="editPost"
        @remove="data?.posts.splice(id, 1)"
        @toggleVisibility="post.visible = !post.visible"
      />
      <div class='ma-12 text-center' v-intersect="infiniteScrolling">
        <v-progress-circular v-if='loading' indeterminate />
      </div>      
    </section>
  </section>
</template>
